import { Star } from "lucide-react";
import { testimonials, reviewAggregate } from "@/data/testimonials";
import myhammerLogo from "@/assets/myhammer.png.asset.json";

function SourceLogo({ source }: { source: "Google" | "Infobel" | "MyHammer" }) {
  if (source === "Google") {
    return (
      <span className="inline-flex items-center gap-1.5">
        <svg viewBox="0 0 48 48" className="h-4 w-4" aria-hidden>
          <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"/>
          <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"/>
          <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"/>
          <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"/>
        </svg>
        <span className="text-xs font-semibold uppercase tracking-wider text-muted-foreground">Google</span>
      </span>
    );
  }
  if (source === "MyHammer") {
    return (
      <img src={myhammerLogo.url} alt="MyHammer" width={80} height={16} loading="lazy" decoding="async" className="h-4 w-auto" />
    );
  }
  return (
    <span className="text-xs font-semibold uppercase tracking-wider text-muted-foreground">{source}</span>
  );
}

export function Testimonials() {
  return (
    <section className="bg-white py-16 md:py-24" aria-labelledby="testimonials-heading">
      <div className="container mx-auto max-w-7xl px-4">
        <div className="text-center mb-12">
          <p className="text-sm font-bold uppercase tracking-wider text-brand-orange">
            Worauf wir wirklich stolz sind
          </p>
          <h2
            id="testimonials-heading"
            className="mt-3 font-display text-3xl font-extrabold text-brand-navy md:text-4xl"
          >
            Echte Kundenmeinungen
          </h2>
          <div className="mt-5 flex flex-wrap items-center justify-center gap-6 text-sm text-muted-foreground">
            <div className="flex items-center gap-2">
              <div className="flex">
                {Array.from({ length: 5 }).map((_, i) => (
                  <Star key={i} className="h-5 w-5 fill-brand-orange text-brand-orange" />
                ))}
              </div>
              <span className="font-semibold text-brand-navy">
                {reviewAggregate.ratingValue}/5
              </span>
              <span>· {reviewAggregate.reviewCount} verifizierte Rezensionen</span>
            </div>
          </div>
        </div>

        <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {testimonials.map((t, i) => (
            <figure
              key={i}
              className="flex flex-col rounded-lg border border-border bg-muted/40 p-6 shadow-sm"
            >
              <div className="flex items-center justify-between">
                <div className="flex">
                  {Array.from({ length: t.rating }).map((_, j) => (
                    <Star key={j} className="h-4 w-4 fill-brand-orange text-brand-orange" />
                  ))}
                </div>
                <SourceLogo source={t.source} />
              </div>
              <blockquote className="mt-4 flex-1 text-sm leading-relaxed text-foreground/85">
                „{t.text}"
              </blockquote>
              <figcaption className="mt-4 border-t border-border pt-3 text-xs text-muted-foreground">
                <span className="font-semibold text-brand-navy">{t.name}</span>
                <span> · {t.date}</span>
              </figcaption>
            </figure>
          ))}
        </div>

        <p className="mt-8 text-center text-xs text-muted-foreground">
          Bewertungen werden auf Google und Infobel öffentlich angezeigt und nicht von uns
          überprüft oder gefiltert.
        </p>
      </div>
    </section>
  );
}
